import { ITargetedDenialAnalysisInstReportPopupContentState, ITargetedDenialAnalysisInstReportPopupFooterState, ITargetedDenialAnalysisInstitutionalReportPopupState, 
    ITargetedDenialAnalysisInstitutionalWarningPopupState, 
    ITargetedDenialAnalysisProfReportPopupContentState, ITargetedDenialAnalysisProfReportPopupFooterState, ITargetedDenialAnalysisProfessionalReportPopupState, 
    ITargetedDenialAnalysisProfessionalWarningPopupState, 
    ITargetedDenialAnalysisReportPopupContentState, ITargetedDenialAnalysisReportPopupFooterState, ITargetedDenialAnalysisReportPopupState, 
    ITargetedDenialAnalysisRootState, 
    ITargetedDenialAnalysisWarningPopupState} from "./state-types";

const initialPopupFooterState: ITargetedDenialAnalysisReportPopupFooterState = {
    auditCreationToolTipMessage: "",
    isAuditButtonDisabled: true,
    createAuditButtonDisplayText: "Initiate Audit - All",
    isSampleSizeDisable: false
}
  
const initialPopupContentState: ITargetedDenialAnalysisReportPopupContentState = {
    isDataSelected: false,
    filterExpression: "",
    filteredRowCountText: "",
    recordsSelectedText: "Records Selected = 0",
    totalRowCountText: ""
}

const initialWarningPopupState: ITargetedDenialAnalysisWarningPopupState = {
    innerHtml: ""
}

const initialProfPopupFooterState: ITargetedDenialAnalysisProfReportPopupFooterState = {...initialPopupFooterState}
const initialInstPopupFooterState: ITargetedDenialAnalysisInstReportPopupFooterState = {...initialPopupFooterState}

const initialProfPopupContentState: ITargetedDenialAnalysisProfReportPopupContentState = {...initialPopupContentState}
const initialInstPopupContentState: ITargetedDenialAnalysisInstReportPopupContentState = {...initialPopupContentState}

const initialProfWarningPopupState: ITargetedDenialAnalysisProfessionalWarningPopupState = {...initialWarningPopupState}
const initialInstWarningPopupState: ITargetedDenialAnalysisInstitutionalWarningPopupState = {...initialWarningPopupState}
    

const initialReportPopupState: ITargetedDenialAnalysisReportPopupState = {
    reportTablePopupTitle: "",
    selectedAuditsProvider: [],
    reportPopupDataGridSelectedAuditsList: [],
    reportPopupDataGridColumns: [],
}
  
const initialtargetedDenialAnalysisProfessionalReportPopupState: ITargetedDenialAnalysisProfessionalReportPopupState = {
    selectedInsightIdForProfessional: { value: "" },
    popupFooterState: initialProfPopupFooterState,
    popupContentState: initialProfPopupContentState,
    warningPopupState: initialInstWarningPopupState,
    ...initialReportPopupState
}

const initialtargetedDenialAnalysisInstitutionalReportPopupState: ITargetedDenialAnalysisInstitutionalReportPopupState = {
    selectedInsightIdForInstitutional: { value: "" },
    popupFooterState: initialInstPopupFooterState,
    popupContentState: initialInstPopupContentState,
    warningPopupState: initialProfWarningPopupState,
    ...initialReportPopupState
}

const initialTargetedDenialAnalysisRootState: ITargetedDenialAnalysisRootState = {
    targetedDenialAnalysisProfessionalPopupReportState: initialtargetedDenialAnalysisProfessionalReportPopupState,
    targetedDenialAnalysisInstitutionalPopupReportState: initialtargetedDenialAnalysisInstitutionalReportPopupState,
    targetedDenialAnalysisWarningMessageInnerHtml: "",
};

  export default initialTargetedDenialAnalysisRootState;